// src/hooks/useUserProfile.js
import { useState, useEffect, useCallback } from "react";
import { useUser } from "@clerk/clerk-react";
import { useApi } from "../apiClient";

export function useUserProfile() {
  const { isSignedIn, user: clerkUser } = useUser();
  const api = useApi();
  const [userProfile, setUserProfile] = useState(null);

  const fetchProfile = useCallback(() => {
    if (!isSignedIn) { setUserProfile(null); return; }
    api.profile.get().then(setUserProfile).catch(() => setUserProfile(null));
  }, [isSignedIn, api]);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return { user: clerkUser, userProfile };
}
